<template>
	<v-layout :class="layoutClass" class="pb-2" id="layout">
		<template v-for="(field, i) in fieldsset.fields">
			<v-flex :key="i" :class="field.class ? field.class : 'lg6 md6 xs12 px-4'" class="pl-2 pr-2 py-0 disabled" v-if="model[field.depends_key] == field.depends_value">

				<template v-if="field.type === 'text-editor' ">
					<v-subheader class="pl-0">{{field.label}}</v-subheader>
					<vue-editor
						:id="'text-editor' + i"
						v-model="model[field.key]"
						ref="editor"
					></vue-editor>
				</template>		

				<template v-else-if="field.type === 'text-area'">
					<v-textarea
					:label="field.label"
					v-model="model[field.key]"
					></v-textarea>
				</template>
					
				<v-autocomplete
					v-else-if="field.type === 'belongsTo' || field.type === 'generalTypes' || field.type === 'morphTo' || field.type === 'customBelongsTo'"
					:label="field.required ? field.label + '*' : field.label"
					:items="field.options"
					:hint="field.hint"
					:persisten-hint="field.persistent_hint"
					v-model="model[field.key]"
					:item-text="field.item_text ? field.item_text : 'text' "
					:item-value="field.item_value ? field.item_value : 'value'"
					:multiple="field.multiple"
					:menu-props="{maxHeight:'200'}"
					:return-object="field.return_object"
					clearable
					:error-messages="errors.collect(field.label)"
					v-validate="field.validations ? field.validations : ''"
					:data-vv-name="field.label"
					:disabled="field.disabled"
					dense
					:search-input.sync="search[field.key]"
					box
					@change="selectChange(field, $event)"
					>
					<template v-if="field.select_all">
						<v-list-tile
							slot="prepend-item"
							ripple
							@click="toggle(field)"
							>
							<v-list-tile-action class="pl-2" v-if="model[field.key] && model[field.key].length == field.options.length">
								<v-icon :color="field.options.length > 0 ? 'amber darken-1' : ''">check_box</v-icon>
							</v-list-tile-action>					
							<v-list-tile-action class="pl-2" v-else-if="model[field.key] && model[field.key].length > 0">
								<v-icon :color="field.options.length > 0 ? 'amber darken-1' : ''">indeterminate_check_box</v-icon>
							</v-list-tile-action>					
							<v-list-tile-action class="pl-2" v-else>
								<v-icon :color="field.options.length > 0 ? 'amber darken-1' : ''">check_box_outline_blank</v-icon>
							</v-list-tile-action>
							<v-list-tile-title>Seleziona tutti</v-list-tile-title>
						</v-list-tile>
						<v-divider
							slot="prepend-item"
							class="mt-1"
						></v-divider>
					</template>
					<template slot="selection" slot-scope="data">
						<v-chip 
							:close="field.close"
							:multiple="field.multiple"
							small
							@input="data.parent.selectItem(data.item)"
							:selected="data.selected"
							class="chip--select-multi"
							:key="JSON.stringify(data.item)">
							<v-avatar v-if="data.item.avatar"
								class="custom-avatar"
								:style="{'background-image': 'url(' + data.item.avatar + ')', 'width': '24px !important', 'height': '24px !important'}">
							</v-avatar>					
							<v-avatar v-else-if="getIcon(data.item)"
								style="min-width: 24px !important; width: 24px !important; height: 24px !important; border-radius: 50%"
								class="amber darken-1 mr-3">
								<v-icon class="fs16i" color="white">{{ getIcon(data.item) }}</v-icon>
							</v-avatar>					
							<v-avatar class="amber darken-1" style="color: white !important" v-else-if="field.chips">
								{{ data.item[field.item_text] ? data.item[field.item_text].slice(0, 1).toUpperCase() : ''}}
							</v-avatar>
							{{ field.item_text ? data.item[field.item_text] : data.item.text }}
						</v-chip>
					</template>
					<template
						slot="item"
						slot-scope="data">
						<template v-if="typeof data.item !== 'object'">
							<v-list-tile-content v-text="data.item"></v-list-tile-content>
						</template>
						<template v-else>
							<v-list-tile-avatar v-if="getIcon(data.item)"
								size="32px"
								style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
								class="amber darken-1 mr-3">
								<v-icon class="fs18i" color="white">{{ getIcon(data.item) }}</v-icon>
							</v-list-tile-avatar>
							<v-list-tile-avatar v-else-if="data.item.avatar">
								<v-avatar
									class="custom-avatar"
									:size="38" 
									:style="{'background-image': 'url(' + data.item.avatar + ')', }">
								</v-avatar>
							</v-list-tile-avatar>
							<v-list-tile-avatar v-else-if="field.chips"
								size="34px"
								style="min-width: 34px; width: 34px; height:34px; border-radius: 50%"
								class="amber darken-1 mr-3">
								<span style="color: white !important" class="margin-auto">{{ data.item.name ? data.item.name.slice(0, 1).toUpperCase() : ''}}</span>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>{{ field.item_text ? data.item[field.item_text] : data.item.text }}</v-list-tile-title>
								<v-list-tile-sub-title v-html="data.item.subtitle"></v-list-tile-sub-title>
							</v-list-tile-content>
						</template>
					</template>
					<template v-if="field.add_new && search[field.key]" slot="no-data">
						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-title>
									Nessun risultato per "<strong>{{ search[field.key] }}</strong>".
									<v-btn flat right small class="ml-4" style="margin: 0px; float: right" color="primary" @click="addNew(field)">Crea Nuovo</v-btn>
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>
				</v-autocomplete>


				<v-combobox v-else-if="field.type === 'chips'"
					:label="field.required ? field.label + '*' : field.label"
					:small-chips="field.chips"
					:clearable="field.clearable"
					:multiple="field.multiple"
					:tags="field.tags"
					return-object
					v-model="model[field.key]"
					:error-messages="errors.collect(field.label)"
					v-validate="field.validations ? field.validations : ''"
					:data-vv-name="field.label"
					dense
				></v-combobox>

				<v-subheader v-else-if="field.type === 'label'" 
					class="pl-0">
					{{field.label}}
				</v-subheader>

				<template v-else-if="field.type === 'checkbox'">
					<v-checkbox
						:label="field.label"
						v-model="model[field.key]"
						color="primary"
						:input-value="[true,false]"
					></v-checkbox>
				</template>
				
				<v-text-field v-else-if="field.type === 'password'"
					:label="field.required ? field.label + '*' : field.label"
					:name="field.key"
					v-model="model[field.key]"
					:item-text="field.item_text ? field.item_text : 'text' "
					:item-value="field.item_value ? field.item_value : 'value'"
					:error-messages="errors.collect(field.label)"
					v-validate="field.validations ? field.validations : ''"
					:data-vv-name="field.label"
					:append-icon="e1 ? 'visibility' : 'visibility_off'"
					@click:append="() => {e1 = !e1}"
					:type="!e1 ? 'password' : 'text'"
					:ref="field.key"
					box
				></v-text-field>
				<template v-else-if="field.type === 'repeat_password'">
					<v-text-field  v-if="model.password" 
						:label="field.label"
						:name="field.key"
						v-model="model[field.key]"
						:error-messages="errors.collect(field.label)"
						v-validate="'confirmed:password|required'"
						:data-vv-name="field.label"
						:append-icon="e2 ? 'visibility' : 'visibility_off'"
						@click:append="() => {e2 = !e2}"
						:type="!e2 ? 'password' : 'text'"
						box
					></v-text-field>
				</template>

				<template v-else-if="field.type === 'color'">
					<v-subheader>Colore</v-subheader>
					<div>
						<swatches 
							v-model="model[field.key]"
							inline
							colors="material-basic"
						></swatches>
					</div>
				</template>

				<template v-else-if="field.type === 'date'">
					<v-menu
						:ref="field.key"
						:close-on-content-click="false"
						v-model="datepicker_menu[field.key]"
						:return-value.sync="model[field.key]"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px"
						:nudge-right="40"
						style="width: 100%"
						>
						<v-text-field
							slot="activator"
							:label="field.required ? field.label + '*' : field.label"
							append-icon="event"
							readonly
							:value="$eventBusUtility.formatDate(model[field.key])"
							:suffix="field.suffix ? field.suffix : ''"
							:error-messages="errors.collect(field.label)"
							v-validate="field.validations ? field.validations : ''"
							:data-vv-name="field.label"
							box
						></v-text-field>
						<v-date-picker 
							v-model="model[field.key]"
							color="primary"
							locale="It"
							@input="$refs[field.key][0].save(model[field.key])"
						></v-date-picker>
					</v-menu>

				</template>

				<template v-else-if="field.type === 'time'">
					<v-menu
						:ref="field.key"
						:close-on-content-click="false"
						v-model="timepicker_menu[field.key]"
						:nudge-right="40"
						:return-value.sync="model[field.key]"
						lazy
						transition="scale-transition"
						offset-y
						full-width
						max-width="290px"
						min-width="290px"
						style="width: 100%"
						>
						<v-text-field
							slot="activator"
							:label="field.required ? field.label + '*' : field.label"
							append-icon="access_time"
							readonly
							v-model="model[field.key]"
							:suffix="field.suffix ? field.suffix : ''"
							:error-messages="errors.collect(field.label)"
							v-validate="field.validations ? field.validations : ''"
							:data-vv-name="field.label"
							box
						></v-text-field>
						<v-time-picker 
							v-model="model[field.key]" 
							@change="$refs[field.key][0].save(model[field.key])"
							format="24hr"
						></v-time-picker>
					</v-menu>
				</template>

				<v-switch v-else-if="field.type === 'boolean'"
					class="text-xs-center"
					tabindex="10"
					:label="field.label"
					v-model="model[field.key]"
					:disabled="field.disabled"
					:input-value="[true,false]"
					color="primary"
				></v-switch>

				<v-text-field v-else-if="field.type == 'number'"
					type="number"
					:label="field.required ? field.label + '*' : field.label"
					v-model.number="model[field.key]"
					:suffix="field.suffix ? field.suffix : ''"
					:error-messages="errors.collect(field.label)"
					v-validate="field.validations ? field.validations : ''"
					:data-vv-name="field.label"
					color="primary"
					box
				></v-text-field>

				<div v-else-if="field.type == 'space'">
					
				</div>

				<v-textarea v-else-if="field.type == 'textarea'"
					v-model="model[field.key]"
					auto-grow
					box
					color="primary"
					:label="field.required ? field.label + '*' : field.label"
					rows="2"
				></v-textarea>
				<v-text-field v-else-if="field.type === 'start_time'"
					:type="field.type ? field.type : 'text'"
					:label="field.required ? field.label + '*' : field.label"
					:disabled="field.disabled"
					:mask="field.mask"
					name="start_time"
					:return-masked-value="field.returnMaskedValue"
					v-model="model[field.key]"
					:error-messages="errors.collect(field.label)"
					:data-vv-name="field.label"
					v-validate="'is_time|required'"
					ref="start_time"
					box
				></v-text-field>
				<v-text-field v-else-if="field.type === 'end_time'"
					:type="field.type ? field.type : 'text'"	
					:label="field.label"
					:mask="field.mask"					
					name="end_time"
					:return-masked-value="field.returnMaskedValue"
					v-model="model[field.key]"
					:error-messages="errors.collect(field.label)"
					:data-vv-name="field.label"
					v-validate="'required|is_time|is_time_correct:'+model['start_time']"
					ref="end_time"
					box
				></v-text-field>
				<v-text-field v-else
					:type="field.type ? field.type : 'text'"
					:label="field.required ? field.label + '*' : field.label"
					:disabled="field.disabled"
					:mask="field.mask"
					:name="field.key"
					:return-masked-value="field.returnMaskedValue"
					v-model="model[field.key]"
					:suffix="field.suffix ? field.suffix : ''"
					:error-messages="errors.collect(field.label)"
					v-validate="field.validations ? field.validations : ''"
					:data-vv-name="field.label"
					box
					color="primary"
				></v-text-field>

			</v-flex>
		</template>

		<v-layout row justify-center>
			<v-dialog v-model="showDialog"
				max-width="600px"
				persistent lazy
				:fullscreen="$vuetify.breakpoint.xsOnly">
				<v-card>
					<v-toolbar flat color="grey lighten-4">
						<v-toolbar-title class="pl-3 grey--text text--darken-4">
							Nuovo
						</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<v-divider></v-divider>
					<v-card-text class="pa-0">
						<v-container fluid pa-2>
							<fields-generator
								:layoutClass="['row','wrap']" 
								:fieldsset.sync="fieldssetNew"
								:model="modelNew"
								ref="dialogfieldsgenerator"
								type="create"
							></fields-generator>
							<small class="pl-4">* Indica i campi obbligatori</small>
						</v-container>
					</v-card-text>
					<v-card-actions class="px-2">
						<v-spacer></v-spacer>
						<v-btn color="amber darken-1" flat @click.native.stop="closeDialog()">Chiudi</v-btn>
						<v-btn color="amber darken-1" flat @click.native="storeNew()">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>
	</v-layout>
</template>

<script>
import Vue from 'vue'
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.min.css"

export default {
	name: 'fields-generator',
	components: { 
		Swatches
	},
	props: {
		layoutClass: Array,
		fieldsset: Object,
		model: Object,
		file: {
			type: Object,
			default: null
		},
		selectChange: {
			type: Function,
			default: function() {
				return null
			}
		}
	},

	data() {
		return {
			datepicker_menu: {},
			timepicker_menu: {},
			e1: false,
			e2: false,
			cloneFields: this.fieldsset.fields,
			fieldIndex: null,
			//
			fieldssetNew: {},
			modelNew: {},
			showDialog: false,
			search: {},
			currentFieldToAdd: {},
		}
	},

	methods: {
		getIcon(item) {
			if (typeof item.icon !== 'undefined') {
				return item.icon
			} else if (item.extra_fields && typeof item.extra_fields == 'string' && JSON.parse(item.extra_fields).icon) {
				return JSON.parse(item.extra_fields).icon
			} else {
				return false
			}
		},

		addNew(field) {
			this.axios.get(field.add_new_url + '/create').then(response => {
				// get body data
				this.currentFieldToAdd = field
				this.model[field.key] = ''
				this.fieldssetNew = response.data
				this.modelNew[field.relation_field] = this.search[field.key]
				// Take only required and set default value
				this.fieldssetNew.fields  = _.filter(response.data.fields.fields, (f) => {
					if(f.default) {
						Vue.set(this.modelNew, f.key, f.default)
					}
					// set values in add_new_related_key in modelNew
					if(field.add_new_related_key && field.add_new_related_key.includes(f.key)) {
						Vue.set(this.modelNew, [f.key], this.model[f.key])
					}
					return f.required === true || f.quick_add === true
				})
				this.showDialog = true
			}, response => {
					// error callback
			});
		},

		closeDialog() {
			this.showDialog = false
			this.modelNew = {}
		},

		storeNew() {
			this.$refs.dialogfieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return false
				}
				this.axios.post(this.currentFieldToAdd.add_new_url, this.modelNew).then(response => {
					_.forEach(this.fieldsset.fields, (field, k) => {
						if(field.key === this.currentFieldToAdd.key) {
							this.fieldsset.fields[k].options.push(response.data.option)
						}
					})
					Vue.set(this.model, [this.currentFieldToAdd.key], response.data.id)
					this.closeDialog()
				}, response => {
					// error callback
				});
			}).catch(() => {
			})
		},

		toggle(field) {
			Vue.nextTick(() => {
				if (this.model[field.key] == undefined) {
					Vue.set(this.model, [field.key], [])
				}
				if (this.model[field.key] && this.model[field.key].length > 0) {
					this.model[field.key] = []
				} else {
					_.forEach(field.options, o => {
						this.model[field.key].push(o)
					})
				}
			})
		}
	}
}
</script>
<style type="text/css">
.expansion-panel__header {
  padding-left: 0px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
